import { useEffect, useState } from 'react'

import { GetSubscriber } from '../api/subscriber/SubscriberApi'

const useLoadSubscriber = ({
  idList,
  listGuid,
  idUser,
  userHash
}) => {
  //  status:  initial | loading | ready | error
  //  errorType: 

  const [data, setData] = useState({
    status: 'initial',
    errorType: undefined,
    data: undefined,
    email: undefined,
    mobilePrefix: undefined,
    mobileNumber: undefined,
    dynamicFields: undefined,
    groups: undefined
  })



  useEffect(() => {

    setData({ status: 'loading' })

    GetSubscriber({
      idList,
      listGuid,
      idUser,
      userHash
    }).then(r => {

      setData({
        status: 'ready',
        data: {
          email: r.Email,
          mobilePrefix: r.MobilePrefix,
          mobileNumber: r.MobileNumber,
          dynamicFields: r.DynamicFields,
          groups: r.Groups,
        }
      })
    }).catch(e => {

      const errorType =
        e.message === 'Invalid listGuid'
          || e.message === 'Invalid subscriber'
          || e.message.startsWith('Invalid idList')
          ? 'wrong-params'
          : undefined
      setData({ status: 'error', errorType })
    })


  }, [idList, listGuid, idUser, userHash])

  return data
}

export default useLoadSubscriber